import React from 'react';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { RotateCcw, Shield, AlertCircle, CheckCircle } from 'lucide-react';

export default function ReturnsPage() {
  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      <Header />
      
      <div className="container mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 
            className="text-4xl md:text-5xl font-bold text-[#2C3E2D] mb-4"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            Returns & Exchanges
          </h1>
          <p className="text-[#5A6B5C] text-lg mb-12">
            We stand behind our products. Learn about our return policy.
          </p>

          <div className="bg-[#4A6741] p-6 rounded-xl mb-12">
            <div className="flex items-center space-x-4">
              <Shield className="h-12 w-12 text-white flex-shrink-0" />
              <div>
                <h2 className="text-xl font-bold text-white mb-1">30-Day Satisfaction Guarantee</h2>
                <p className="text-white/80">If you're not completely satisfied with your purchase, return it within 30 days for a full refund or exchange.</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-xl border border-[#E8E4DC] space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4 flex items-center space-x-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
                <CheckCircle className="h-6 w-6 text-[#4A6741]" />
                <span>Eligible for Return</span>
              </h2>
              <ul className="space-y-3 text-[#5A6B5C]">
                <li className="flex items-start space-x-3">
                  <span className="text-[#4A6741]">✓</span>
                  <span>Unused items in original packaging</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-[#4A6741]">✓</span>
                  <span>Items with manufacturing defects</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-[#4A6741]">✓</span>
                  <span>Wrong item shipped</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-[#4A6741]">✓</span>
                  <span>Damaged during shipping</span>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4 flex items-center space-x-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
                <AlertCircle className="h-6 w-6 text-[#D4A55A]" />
                <span>Not Eligible for Return</span>
              </h2>
              <ul className="space-y-3 text-[#5A6B5C]">
                <li className="flex items-start space-x-3">
                  <span className="text-[#EF4444]">✗</span>
                  <span>Custom-built clubs that have been used</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-[#EF4444]">✗</span>
                  <span>Items returned after 30 days</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-[#EF4444]">✗</span>
                  <span>Items without original packaging</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-[#EF4444]">✗</span>
                  <span>Damage caused by misuse or normal wear</span>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4 flex items-center space-x-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
                <RotateCcw className="h-6 w-6 text-[#4A6741]" />
                <span>How to Return</span>
              </h2>
              <ol className="space-y-4 text-[#5A6B5C]">
                <li className="flex items-start space-x-3">
                  <span className="bg-[#4A6741] text-white text-sm font-bold w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0">1</span>
                  <span>Contact us at nbond@tortlab.com with your order number and reason for return.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="bg-[#4A6741] text-white text-sm font-bold w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0">2</span>
                  <span>We'll email you a prepaid return shipping label within 24-48 hours.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="bg-[#4A6741] text-white text-sm font-bold w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0">3</span>
                  <span>Pack the item securely in its original packaging and attach the return label.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="bg-[#4A6741] text-white text-sm font-bold w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0">4</span>
                  <span>Drop off at any UPS or FedEx location.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="bg-[#4A6741] text-white text-sm font-bold w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0">5</span>
                  <span>Refunds are processed within 5-7 business days after we receive the item.</span>
                </li>
              </ol>
            </div>

            <div className="bg-[#F5F3EF] p-6 rounded-lg">
              <h3 className="font-bold text-[#2C3E2D] mb-2">Questions?</h3>
              <p className="text-[#5A6B5C] text-sm">
                Contact our customer service team at <a href="mailto:nbond@tortlab.com" className="text-[#4A6741] hover:underline">nbond@tortlab.com</a> or call 1-800-GOLF-FIT.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}
